import { Box, Checkbox, Tab, Tabs } from "@mui/material";
import { format } from "date-fns";
import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonTransactionPaginationTable from "../../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import CommonTransactionTable from "../../../../../common/components/CommonTable/CommonTransactionTable";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
// import { useGetUserActions } from "../../../../../common/components/Custom Hooks/useGetUserActions";
import DatePickerField from "../../../../../common/components/FormFields/DatePickerField";
import DropdownField from "../../../../../common/components/FormFields/DropdownField";
import RadioField from "../../../../../common/components/FormFields/RadioField";
import SearchBar from "../../../../../common/components/FormFields/SearchBar";
import SearchDropdown from "../../../../../common/components/FormFields/searchDropdown";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../../../common/components/Toasts/CustomToasts";
import { autoSearchCssdItemKit } from "../../../../services/commonservices/commonservices";
import { getStoreDropdown } from "../../../../services/commonservices/commonservices";
import {
  fetchTransferCssdItemsKitListCSSDRe,
  fetchTransferCssdItemsListStock,
  saveTransferCssdItemsListStock,
} from "../../../../services/transferReceiveCssdServices/TransferReceiveCssdServices";
import { UseCheckConsecutiveCharacters } from "../../../../../common/components/Custom Hooks/UseCheckConsecutiveCharacters";

const itemType = [
  { label: "Kit", value: "Kit", id: "Kit" },
  { label: "Item", value: "Item", id: "Item" },
];

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const SterilizationProcessingAddToStock = (props) => {
  const location = useLocation();
  const getUserInfo = JSON.parse(localStorage?.getItem("loggedUser"));
  const [packagingItemList, setPackagingItemList] = useState([]);
  const [packagingKitList, setPackagingKitList] = useState([]);
  const [packagingKitItemsList, setPackagingKitItemsList] = useState([]);
  const [page, setPage] = useState(0);
  const [kitPage, setKitPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [kitRowsPerPage, setKitRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [kitCount, setKitCount] = useState(null);
  const [openPostModal, setOpenPostModal] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [userActions, setUserActions] = useState([]);
  const [itemKitOptions, setItemKitOptions] = useState([]);
  const [selectedKitRows, setSelectedKitRows] = useState({});
  const [kitListingObject, setKitListingObject] = useState({
    searchString: "",
    searchId: null,
    fromDate: null,
    toDate: null,
    page: page,
    size: rowsPerPage,
  });
  const [storeOptions, setStoreOptions] = useState([]);
  const [values, setValues] = useState(null);
  const [searchBarId, setSearchBarId] = useState(null);
  const [searchBarString, setSearchBarString] = useState("");

  const handleChange = (event, newValue) => {
    setValues(newValue);
  };

  const defaultValues = {
    fromDate: null,
    toDate: null,
    itemType: "Kit",
    fromStore: null,
  };
  const {
    control,
    watch,
    setError,
    clearErrors,
    setValue,
    register,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
  });

  let getFromDate = watch("fromDate");
  let getToDate = watch("toDate");
  let getItemType = watch("itemType");
  let getStore = watch("fromStore");

  const populateItemTable = (forPagination) => {
    let listObj = {
      searchString: "",
      searchId: null,
      fromDate: null,
      toDate: null,
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      processType: "completion",
      kitId: null,
    };

    // fetchTransferCssdItemsListStock(listObj).then((response) => {
    //   if (forPagination) {
    //     setPackagingItemList((prevData) => [
    //       ...prevData,
    //       ...response.data.result?.map((val) => ({
    //         Select: true,
    //         "Item Code": val?.["Item Code"],
    //         "Item Name": val?.["Item Name"],
    //         ...val,
    //         "AddToStock Qty": val?.["Sterilization Qty"],
    //         "Old AddToStock Qty": val?.["Sterilization Qty"],
    //       })),
    //     ]);
    //   } else {
    //     setPackagingItemList(
    //       response.data.result?.map((val) => ({
    //         Select: true,
    //         "Item Code": val?.["Item Code"],
    //         "Item Name": val?.["Item Name"],
    //         ...val,
    //         "AddToStock Qty": val?.["Sterilization Qty"],
    //         "Old AddToStock Qty": val?.["Sterilization Qty"],
    //       }))
    //     );
    //     setPage(0);
    //   }
    //   setCount(response.data.count);
    // }).catch((err) => {
    //   errorAlert(err?.message)
    // })
  };

  const handleFromStoreChange = (inputValue) => {
    if (typeof inputValue !== "string") return;

    setSearchBarString(inputValue);

    const trimmedValue = inputValue.trim();

    if (
      trimmedValue.length > 0 &&
      UseCheckConsecutiveCharacters(trimmedValue)
    ) {
      getStoreDropdown(trimmedValue)
        .then((res) => {
          setStoreOptions(res?.data?.result ?? []);
        })
        .catch(() => {
          setStoreOptions([]);
        });
    } else {
      setStoreOptions([]);
    }
  };


  const handleReceiveCSSDSearch = async () => {
    try {
      const payload = {
        searchString: watch("searchByItem") || null,
        page: kitPage,
        size: kitRowsPerPage,
        fromDate: format(getFromDate, "yyyy-MM-dd"),
        toDate: format(getToDate, "yyyy-MM-dd"),
        searchId: null,
        processType: "completion",
        storeId: watch("fromStore")?.value ?? null
      };

      console.log("sterilization Payload:", payload);

      const res = await fetchTransferCssdItemsKitListCSSDRe(payload);

      const tableData = (res?.data?.result || []).map(item => ({
        Select: false,
        ...item
      }));

      setPackagingKitList(tableData);

    } catch (error) {
      console.error("completion API Error:", error);
    }
  };

  const populateKitTable = (forPagination) => {
    let listObj = {
      searchString: kitListingObject?.searchString,
      searchId: kitListingObject?.searchId,
      fromDate: kitListingObject?.fromDate,
      toDate: kitListingObject?.toDate,
      page: !forPagination ? 0 : page,
      size: rowsPerPage,
      processType: "completion",
    };
    fetchTransferCssdItemsKitListCSSDRe(listObj).then((response) => {
      if (forPagination) {
        setPackagingKitList((prevData) => [
          ...prevData,
          ...response?.data?.result?.map((val) => ({
            Select: false,
            // "Item Kit Code": val?.["Item Kit Code"],
            // "Item Kit Name": val?.["Item Kit Name"],
            ...val,
          })),
        ]);
      } else {
        setPackagingKitList(
          response.data.result?.map((val) => ({
            Select: false,
            // "Item Kit Code": val?.["Item Kit Code"],
            // "Item Kit Name": val?.["Item Kit Name"],
            ...val,
          }))
        );
        setKitPage(0);
      }
      setKitCount(response.data.count);
    });
  };

  const populateKitItemTable = (id, kitBatchNo, KitName, kitId, kitName, srNo) => {
    let listObj = {
      searchString: "",
      searchId: null,
      fromDate: null,
      toDate: null,
      processType: "completion",
      kitId: kitId,
      page: null,
      size: null,
    };
    // fetchTransferCssdItemsListStock(id, kitBatchNo, KitName).then((response) => {
    //   let newItems =
    //     response?.data?.statusCode === 200
    //       ? response?.data?.result?.map((val) => ({
    //         Select: true,
    //         "id": val?.["id"],
    //         "Item Code": val?.["item_id"],
    //         "Item Name": val?.["ItemName"],
    //         "kitId": val?.["item_kit_id"],
    //         "kitBatchNo": val?.["kitBatchNo"],
    //         // ...val,
    //         "AddToStock Qty": val?.["quantity"],
    //         "Old AddToStock Qty": val?.["Sterilization Qty"],
    //       }))
    //       : [];

    const groupedKits = Object.values(
      packagingKitItemsList.reduce((acc, item) => {
        const kitId = item.kitId || 0;

        if (!acc[kitId]) {
          acc[kitId] = {
            kitId,
            KitName: item.KitName || `Kit ${kitId}`,
            kitItemList: []
          };
        }

        acc[kitId].kitItemList.push(item);
        return acc;
      }, {})
    );

    fetchTransferCssdItemsListStock(id, kitBatchNo, KitName).then((response) => {
      console.log("kitResponse", response);

      let newItems =
        response?.data?.statusCode === 200
          ? response?.data?.result?.map((val) => ({
            Select: true,
            id: val?.id,
            "Item Code": val?.item_id,
            "Item Name": val?.ItemName,
            // kitId: val?.item_kit_id,    // FIX: "kidId" → "kitId"
            kitId: val?.kitId ?? val?.item_kit_id ?? 0,
            "KitName": val?.KitName,
            "kitBatchNo": val?.["kitBatchNo"],
            "AddToStock Qty": val?.["cleanedQty"],
            "Old AddToStock Qty": val?.["Sterilization Qty"],
            "sterilizationExpiryDate": val?.["sterilizationExpiryDate"],
          }))
          : [];
      let kitObj = {
        kitName: kitName,
        srNo: srNo,
        KitName,
        kitItemList: newItems?.length > 0 ? newItems : [],
      };
      setPackagingKitItemsList((prevData) => [...prevData, { ...kitObj }]);
    }).catch((err) => {
      errorAlert(err?.message)
    })
  };

  console.log("packagingKitItemsList", packagingKitItemsList);

  const renderInputItem = (row, index, header) => {
    if (row?.["Sterilization ExpiryDate"]) {
      setValue(
        `sterilizationExpiryDate${row?.["Item Code"] + row?.["Sr No"]}`,
        row?.["Sterilization ExpiryDate"]?.includes("T")
          ? new Date(row?.["Sterilization ExpiryDate"]?.replace(" ", "T"))
          : new Date(row?.["Sterilization ExpiryDate"]?.replace(" ", "T"))
      );
    }
    return (
      <div className="-my-2">
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`Select${row?.["Sr No"]}`}
            checked={row?.Select}
            onChange={(e) => {
              setPackagingItemList((prevTransferItemList) =>
                prevTransferItemList.map((val, i) =>
                  val?.["Item Code"] === row?.["Item Code"] &&
                    val?.["Sr No"] === row?.["Sr No"]
                    ? { ...val, Select: e.target.checked }
                    : val
                )
              );
            }}
          />
        )}
        {header === "AddToStock Qty" && (
          <input
            type="number"
            name={`addToStockQty${row?.["Sr No"]}`}
            value={row?.["AddToStock Qty"]}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              if (e.target.value <= Number(row?.["Old AddToStock Qty"])) {
                setPackagingItemList((prevTransferItemList) =>
                  prevTransferItemList.map((val, i) =>
                    val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? {
                        ...val,
                        ["Sterilization Qty"]:
                          e.target.value !== ""
                            ? e.target.value
                            : val?.["Old AddToStock Qty"],
                        ["AddToStock Qty"]:
                          e.target.value !== ""
                            ? e.target.value
                            : val?.["Old AddToStock Qty"],
                      }
                      : val
                  )
                );
              }
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )}
      </div>
    );
  };

  const renderInputKit = (row, index, header) => {
    return (
      <div className="-my-2">
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`SelectKit${row?.id}`}
            checked={!!selectedKitRows[row.id]}
            onChange={(e) => {
              const isChecked = e.target.checked;

              // 1️⃣ Update selection state
              setSelectedKitRows((prev) => ({
                ...prev,
                [row.id]: isChecked,
              }));

              // 2️⃣ Update main kit list
              setPackagingKitList((prev) =>
                prev.map((kit) =>
                  kit.id === row.id ? { ...kit, Select: isChecked } : kit
                )
              );
              // 3️⃣ Add OR Remove from kit item list
              if (isChecked) {
                // Set first tab index
                if (packagingKitItemsList.length === 0) {
                  setValues(0);
                }

                // Load kit items
                populateKitItemTable(row.id, row.kitBatchNo, row.KitName);
              } else {
                // Remove kit items of this kit
                setPackagingKitItemsList((prev) =>
                  prev.filter((kit) => kit.id !== row.id)
                );
              }
            }}
          />
        )}
      </div>
    );
  };

  const renderInputKitItem = (row, index, header) => {
    return (
      <div className="-my-2">
        {header === "Select" && (
          <Checkbox
            size="small"
            name={`${values}SelectKitItem${index}`}
            checked={row?.Select}
            onChange={(e) => {
              setPackagingKitItemsList((prevDataObj) =>
                prevDataObj?.map((kit, kitInd) => ({
                  ...kit,
                  kitItemList: kit.kitItemList?.map((val) =>
                    values === kitInd &&
                      val?.["Item Code"] === row?.["Item Code"] &&
                      val?.["Sr No"] === row?.["Sr No"]
                      ? { ...val, Select: e.target.checked }
                      : val
                  ),
                }))
              );
            }}
          />
        )}
        {/* {header === "AddToStock Qty" && (
          <input
            type="number"
            name={`${values}addToStockQty${index}`}
            value={row?.["AddToStock Qty"]}
            className="border border-black rounded w-28 px-2"
            onChange={(e) => {
              if (e.target.value <= Number(row?.["Old AddToStock Qty"])) {
                setPackagingKitItemsList((prevDataObj) =>
                  prevDataObj?.map((kit, kitInd) => ({
                    ...kit,
                    kitItemList: kit.kitItemList?.map((val) =>
                      values === kitInd &&
                        val?.["Item Code"] === row?.["Item Code"] &&
                        val?.["Sr No"] === row?.["Sr No"]
                        ? {
                          ...val,
                          ["Sterilization Qty"]:
                            e.target.value !== ""
                              ? e.target.value
                              : val?.["Old AddToStock Qty"],
                          ["AddToStock Qty"]:
                            e.target.value !== ""
                              ? e.target.value
                              : val?.["Old AddToStock Qty"],
                        }
                        : val
                    ),
                  }))
                );
              }
            }}
            onWheel={(e) => e.target.blur()}
            onKeyDown={(e) =>
              ["ArrowUp", "ArrowDown", "e", "E", "+", "-", "*", "/"].includes(
                e.key
              ) && e.preventDefault()
            }
          />
        )} */}
      </div>
    );
  };

  const allItems = packagingKitItemsList.flatMap(kit =>
    kit.kitItemList?.map(item => ({
      ...item,
      KitName: item.KitName,
      parentKitId: kit.id
    })) || []
  );

  // 2️⃣ Group by real kitId
  const groupedItems = allItems.reduce((acc, item) => {
    const key = item.kitId ?? 0;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {});

  // 3️⃣ For Tabs
  const finalTabs = Object.entries(groupedItems).map(([kitId, items]) => ({
    kitId,
    KitName: items[0]?.KitName || `Kit ${kitId}`,
    items,
  }));

  // const addToStockList = () => {
  //   let itemDetailsArray =
  //     getItemType === "Item"
  //       ? packagingItemList
  //       : packagingKitItemsList
  //         ?.flatMap((val) => val?.kitItemList)
  //         ?.filter((fil) => fil.Select === true);
  //   let postObject = {
  //     id: null,
  //     fromStore: getUserInfo?.loginStoreId,
  //     toStore: getUserInfo?.loginStoreId,
  //     itemDetailsRequestDtoList: itemDetailsArray
  //       ?.filter((val) => val?.Select === true)
  //       ?.map((item) => ({
  //         id: item?.Id,
  //         cssdTransferId: item?.["Cssd Transfer Id"]
  //           ? item?.["Cssd Transfer Id"]
  //           : null,
  //         otDetails:
  //           item?.["Ot Details Id"] !== null
  //             ? {
  //               id: item?.["Ot Details Id"],
  //             }
  //             : null,
  //         item:
  //           item?.["Item Id"] !== null
  //             ? {
  //               id: item?.["Item Id"],
  //             }
  //             : null,
  //         itemKit:
  //           item?.["Item Kit Code"] !== null
  //             ? {
  //               id: item?.["Item Kit Code"],
  //             }
  //             : null,
  //         transferDate:
  //           item?.["Transfer Date"] !== null
  //             ? item?.["Transfer Date"]?.replace(" ", "T")?.split(".")[0]
  //             : null,
  //         transferQty: item?.["Transfer Qty"]
  //           ? Number(item?.["Transfer Qty"])
  //           : null,
  //         transferStatus: item?.["Transfer Status"],
  //         transferredBy:
  //           item?.["Transferred By"] !== null
  //             ? { id: item?.["Transferred By"] }
  //             : null,

  //         issueDate:
  //           item?.["Issue Date"] !== null
  //             ? item?.["Issue Date"]?.replace(" ", "T")
  //             : null,
  //         issueStatus: item?.["Issue Status"],
  //         issueQty:
  //           item?.["Issue Qty"] !== null ? Number(item?.["Issue Qty"]) : null,
  //         issuedBy:
  //           item?.["Issued By"] !== null ? { id: item?.["Issued By"] } : null,

  //         disposedDate:
  //           item?.["Disposed Date"] !== null
  //             ? item?.["Disposed Date"]?.replace(" ", "T")
  //             : null,
  //         disposedQty: item?.["Disposed Qty"]
  //           ? Number(item?.["Disposed Qty"])
  //           : null,
  //         disposedBy:
  //           item?.["Disposed By"] !== null
  //             ? { id: item?.["Disposed By"] }
  //             : null,

  //         receiveDate:
  //           item?.["Receive Date"] !== null
  //             ? item?.["Receive Date"]?.replace(" ", "T")
  //             : null,
  //         receiveQty: item?.["Receive Qty"]
  //           ? Number(item?.["Receive Qty"])
  //           : null,
  //         receiveStatus: item?.["Receive Status"],
  //         receivedBy: item?.["Received By"]
  //           ? { id: item?.["Received By"] }
  //           : null,

  //         cleaningStatus: item?.["Cleaning Status"],
  //         cleanedQty:
  //           item?.["Cleaned Qty"] !== null
  //             ? Number(item?.["Cleaned Qty"])
  //             : null,
  //         cleaningStartDate:
  //           item?.["Cleaning Start Date"] !== null
  //             ? item?.["Cleaning Start Date"]?.replace(" ", "T")
  //             : null,
  //         cleaningEndDate:
  //           item?.["Cleaning End Date"] !== null
  //             ? item?.["Cleaning End Date"]?.replace(" ", "T")
  //             : null,
  //         cleanedBy:
  //           item?.["Cleaned By"] !== null ? { id: item?.["Cleaned By"] } : null,

  //         wrappedQty:
  //           item?.["Wrapped Qty"] !== null
  //             ? Number(item?.["Wrapped Qty"])
  //             : null,
  //         wrappingStatus: item?.["Wrapping Status"],
  //         wrappedBy:
  //           item?.["Wrapped By"] !== null ? { id: item?.["Wrapped By"] } : null,
  //         wrapperType:
  //           item?.["Wrapper Type Id"] !== null
  //             ? { id: item?.["Wrapper Type Id"] }
  //             : null,
  //         wrapperTypeQty:
  //           item?.["Wrapper Type Qty"] !== null
  //             ? item?.["Wrapper Type Qty"]
  //             : null,
  //         wrappingMethod:
  //           item?.["Wrapping Method Id"] !== null
  //             ? { id: item?.["Wrapping Method Id"] }
  //             : null,
  //         wrappingStartDate:
  //           item?.["Wrapping Start Date"] !== null
  //             ? item?.["Wrapping Start Date"]?.replace(" ", "T")
  //             : null,
  //         wrappingEndDate:
  //           item?.["Wrapping End Date"] !== null
  //             ? item?.["Wrapping End Date"]?.replace(" ", "T")
  //             : null,

  //         machine:
  //           item?.["Machine Id"] !== null ? { id: item?.["Machine Id"] } : null,

  //         sterilizationQty:
  //           item?.["Sterilization Qty"] !== null
  //             ? Number(item?.["Sterilization Qty"])
  //             : null,
  //         sterilizationStatus: item?.["Sterilization Status"],
  //         sterilizationStatusType: "complete",
  //         sterilizationStartBy:
  //           item?.["Sterilization Start By"] !== null
  //             ? { id: item?.["Sterilization Start By"] }
  //             : null,
  //         sterilizationEndBy:
  //           item?.["Sterilization End By"] !== null
  //             ? { id: item?.["Sterilization End By"] }
  //             : null,
  //         sterilizationStartDate:
  //           item?.["Sterilization Start Date"] !== null
  //             ? item?.["Sterilization Start Date"]?.replace(" ", "T")
  //             : null,
  //         sterilizationEndDate:
  //           item?.["Sterilization End Date"] !== null
  //             ? item?.["Sterilization End Date"]?.replace(" ", "T")
  //             : null,

  //         sterilizationType:
  //           item?.["Sterilization Equipment Id"] !== null
  //             ? { id: item?.["Sterilization Equipment Id"] }
  //             : null,
  //         sterilizationMethod:
  //           item?.["Sterilization Method Id"] !== null
  //             ? { id: item?.["Sterilization Method Id"] }
  //             : null,
  //         sterilizationExpiryDate:
  //           item?.["Sterilization ExpiryDate"] !== null &&
  //             !item?.["Sterilization ExpiryDate"]?.includes("T")
  //             ? item?.["Sterilization ExpiryDate"]
  //               ?.replace(" ", "T")
  //               ?.replace(".0", ".000Z")
  //             : item?.["Sterilization ExpiryDate"],

  //         addToStockQty:
  //           item?.["AddToStock Qty"] !== null
  //             ? Number(item?.["AddToStock Qty"])
  //             : null,

  //         decontaminationStatus: item?.["Decontamination Status"],

  //         kitBatchNo: item?.["Kit BatchNo"],
  //         itemBatchNo: item?.["Item BatchNo"],
  //         temperature: item?.Temperature,
  //         pressure: item?.Pressure,
  //         indicatorResult:
  //           item?.["Indicator Result"] !== null
  //             ? item?.["Indicator Result"]
  //             : null,
  //         processType: "completion",
  //         cssdLotNo: item?.["CSSD LotNo"],
  //       })),
  //   };
  //   console.log("postObject", postObject);
  //   setOpenPostModal(false);
  //   setOpenBackdrop(true);
  //   saveTransferCssdItemsListStock(postObject)
  //     .then((response) => {
  //       successAlert(response.data.message);
  //       setOpenPostModal(false);
  //       populateItemTable();
  //       setOpenBackdrop(false);
  //     })
  //     .catch((error) => {
  //       errorAlert(error.message);
  //       setOpenBackdrop(false);
  //     });
  // };


  // const addToStockList = async () => {
  //   setOpenBackdrop(true);

  //   try {
  //     // Get all selected items depending on type
  //     const itemDetailsArray =
  //       getItemType === "Item"
  //         ? packagingItemList?.filter((item) => item.Select)
  //         : packagingKitItemsList
  //           ?.flatMap((kit) => kit?.kitItemList)
  //           ?.filter((item) => item.Select) || [];

  //     // If no items, add a default placeholder
  //     if (!itemDetailsArray.length) {
  //       itemDetailsArray.push({
  //         id: 0,
  //         "Item Code": 0,
  //         "Disposed Qty": 0,
  //         "Disposed Reason": "string",
  //         "Cleaned Qty": 0,
  //         "Wrapped Qty": 0,
  //         "Wrapper Type Id": 0,
  //         "Wrapping Method Id": 0,
  //         "Item BatchNo": "string",
  //         "Kit BatchNo": "string",
  //       });
  //     }

  //     // Build payload in array format
  //     const payload = itemDetailsArray.map((item) => ({
  //       id: item?.id || 0,
  //       ot_details_id: item?.["Ot Details Id"] || 0,
  //       item_id: item?.["Item Id"] || item?.["Item Code"] || 0,
  //       item_kit_id: item?.["Item Kit Code"] || 0,
  //       processType: "pending",
  //       quantity: 0,
  //       transferDate: new Date().toISOString(),
  //       transferQty: item?.["Transfer Qty"] ? Number(item?.["Transfer Qty"]) : 0,
  //       transferStatus: true,
  //       transferred_by: item?.["Transferred By"] || 0,
  //       issueDate: item?.["Issue Date"] || new Date().toISOString(),
  //       issueStatus: true,
  //       issueQty: item?.["Issue Qty"] ? Number(item?.["Issue Qty"]) : 0,
  //       issued_by: item?.["Issued By"] || 0,
  //       disposedDate: item?.["Disposed Date"] || new Date().toISOString(),
  //       disposedQty: item?.["Disposed Qty"] || 0,
  //       disposed_by: item?.["Disposed By"] || 0,
  //       disposedReason: item?.["Disposed Reason"] || "string",
  //       receiveDate: item?.["Receive Date"] || new Date().toISOString(),
  //       receiveQty: item?.["Receive Qty"] || 0,
  //       receiveStatus: true,
  //       received_by: item?.["Received By"] || 0,
  //       cleaningStatus: true,
  //       decontaminationStatus: item?.["Decontamination Status"] || true,
  //       cleanedQty: item?.["Cleaned Qty"] || 0,
  //       cleaned_by: item?.["Cleaned By"] || 0,
  //       cleaningStartDate: item?.["Cleaning Start Date"] || new Date().toISOString(),
  //       cleaningEndDate: item?.["Cleaning End Date"] || new Date().toISOString(),
  //       wrappedQty: item?.["Wrapped Qty"] || 0,
  //       wrappingStatus: true,
  //       wrapped_by: item?.["Wrapped By"] || 0,
  //       wrapper_type_id: item?.["Wrapper Type Id"] || 0,
  //       wrapperTypeQty: item?.["Wrapper Type Qty"] || 0,
  //       wrapping_method_id: item?.["Wrapping Method Id"] || 0,
  //       wrappingStartDate: item?.["Wrapping Start Date"] || new Date().toISOString(),
  //       wrappingEndDate: item?.["Wrapping End Date"] || new Date().toISOString(),
  //       sterilizationQty: item?.["Sterilization Qty"] || 0,
  //       sterilizationStatus: true,
  //       sterilizationStatusType: "pending",
  //       sterilization_start_by: getUserInfo?.employeeId || 0,
  //       sterilizationStartDate: new Date().toISOString(),
  //       sterilizationEndDate: item?.["Sterilization End Date"] || new Date().toISOString(),
  //       sterilization_end_by: item?.["Sterilization End By"] || 0,
  //       machine_id: item?.["Machine Id"] || 0,
  //       sterilization_type_id: item?.["Sterilization Equipment Id"] || 0,
  //       sterilization_method: item?.["Sterilization Method Id"] || 0,
  //       sterilizationExpiryDate: item?.["Sterilization ExpiryDate"] || new Date().toISOString(),
  //       addToStockQty: item?.["AddToStock Qty"] || 0,
  //       temperature: item?.Temperature || 0,
  //       pressure: item?.Pressure || 0,
  //       durationMinutes: 0,
  //       indicatorResult: "string",
  //       from_store_id: getUserInfo?.loginStoreId || 0,
  //       to_store_id: getUserInfo?.loginStoreId || 0,
  //       itemBatchNo: item?.["Item BatchNo"] || "string",
  //       kitBatchNo: item?.["Kit BatchNo"] || "string",
  //       cssdLotNo: "string",
  //       createdBy: getUserInfo?.employeeId || "string",
  //       lastModifiedBy: getUserInfo?.employeeId || "string",
  //       createdDate: new Date().toISOString(),
  //       lastModifiedDate: new Date().toISOString(),
  //     }));

  //     console.log("Payload:", payload);

  //     setOpenPostModal(false);

  //     // Call API
  //     const response = await saveTransferCssdItemsListStock(payload);

  //     if (response?.status === 200) {
  //       successAlert("Items successfully sent!");
  //       populateItemTable();
  //       // setSelectedStage("Ongoing");
  //     } else {
  //       errorAlert("Failed to send items");
  //     }
  //   } catch (error) {
  //     console.error("Error sending items:", error);
  //     errorAlert(error.message || "Something went wrong while sending items.");
  //   } finally {
  //     setOpenBackdrop(false);
  //   }
  // };

  // const addToStockList = async () => {
  //   setOpenBackdrop(true);

  //   try {
  //     // ✅ Get all selected items depending on type
  //     const itemDetailsArray =
  //       getItemType === "Item"
  //         ? packagingItemList?.filter((item) => item.Select)
  //         : packagingKitItemsList
  //           ?.flatMap((kit) => kit?.kitItemList)
  //           ?.filter((item) => item.Select) || [];

  //     // ⚠️ If nothing selected, show alert and exit
  //     if (!itemDetailsArray.length) {
  //       errorAlert("Please select at least one item before adding to stock.");
  //       setOpenBackdrop(false);
  //       return;
  //     }

  //     // ✅ Build payload in the expected format
  //     const payload = itemDetailsArray.map((item) => ({
  //       // id: item?.id || 0,
  //       id: null,
  //       itemId: item?.["Item Id"] || item?.["Item Code"] || 0,
  //       storeId: getUserInfo?.loginStoreId || 0,
  //       kitId: item?.["Kit Id"] || item?.["Item Kit Code"] || 0,
  //       qty:
  //         Number(item?.["AddToStock Qty"]) ||
  //         Number(item?.["Receive Qty"]) ||
  //         Number(item?.["Transfer Qty"]) ||
  //         0,
  //       batchCode:
  //         item?.["Item BatchNo"] ||
  //         item?.["Kit BatchNo"] ||
  //         item?.batchCode ||
  //         "N/A",
  //     }));

  //     console.log("📦 Final Payload Sent to API:", payload);

  //     // ✅ Close modal before sending
  //     setOpenPostModal(false);

  //     // ✅ Send API request
  //     const response = await saveTransferCssdItemsListStock(payload);

  //     // ✅ Handle response
  //     if (response?.status === 200) {
  //       successAlert("Stock data saved successfully!");
  //       populateItemTable(); // refresh list
  //     } else {
  //       errorAlert("Failed to save stock data.");
  //     }
  //   } catch (error) {
  //     console.error("❌ Error while saving stock data:", error);
  //     errorAlert(error.message || "Something went wrong while saving stock data.");
  //   } finally {
  //     setOpenBackdrop(false);
  //   }
  // };

  const addToStockList = async () => {
    setOpenBackdrop(true);

    try {
      // ✅ Get selected items based on type
      const itemDetailsArray =
        getItemType === "Item"
          ? packagingItemList?.filter((item) => item.Select)
          : packagingKitItemsList
            ?.flatMap((kit) => kit?.kitItemList)
            ?.filter((item) => item.Select) || [];

      // ⚠️ If nothing selected
      if (!itemDetailsArray.length) {
        errorAlert("Please select at least one item before adding to stock.");
        setOpenBackdrop(false);
        return;
      }

      const addToStockQtyErrors = [];

      itemDetailsArray.forEach((item, index) => {
        const addToStockQty = Number(item["AddToStock Qty"]);

        if (!addToStockQty || isNaN(addToStockQty) || addToStockQty <= 0) {
          addToStockQtyErrors.push(
            `Row ${index + 1}: AddToStock Qty must be greater than 0`
          );
        }
      });

      if (addToStockQtyErrors.length) {
        warningAlert(addToStockQtyErrors.join("\n"));
        setOpenBackdrop(false);
        return;
      }


      // ✅ Prepare payload
      const payload = itemDetailsArray.map((item) => ({
        // id: null,
        id: item?.id || 0,
        processType: "addtostock",
        itemId: item?.["Item Id"] || item?.["Item Code"] || 0,
        storeId: getUserInfo?.loginStoreId || 0,
        kitId: item?.["kitId"] || 0,
        qty:
          Number(item?.["AddToStock Qty"]) ||
          Number(item?.["Receive Qty"]) ||
          Number(item?.["Transfer Qty"]) ||
          0,
        batchCode: item?.["kitBatchNo"] || 0,
        sterilizationExpiryDate: item?.["sterilizationExpiryDate"] || 0,
      }));

      console.log("✅ Final Payload Sent:", payload);

      // ✅ Close modal
      setOpenPostModal(false);

      // ✅ Call API
      const response = await saveTransferCssdItemsListStock(payload);

      if (response?.status === 200) {
        successAlert("Stock data saved successfully!");

        // ✅ Refresh main table (fetch fresh data)
        await populateItemTable();

        // ✅ Clear all selected data (for both items & kits)
        setPackagingItemList([]);
        setPackagingKitItemsList([]);
        setPackagingKitList([]);
      } else {
        errorAlert("Failed to save stock data.");
      }
    } catch (error) {
      console.error("❌ Error while saving stock data:", error);
      errorAlert(error.message || "Something went wrong while saving stock data.");
    } finally {
      setOpenBackdrop(false);
    }
  };

  console.log("packagingItemList", packagingItemList);

  const handleItemKitChange = (autoSearchString) => {
    if (
      autoSearchString !== "" &&
      UseCheckConsecutiveCharacters(autoSearchString)
    ) {
      setSearchBarString(autoSearchString);
      autoSearchCssdItemKit(autoSearchString, "cssd")
        .then((response) => response.data)
        .then((res) => {
          setItemKitOptions(res.result);
        });
    } else if (autoSearchString === "") {
      setSearchBarString("");
      setItemKitOptions([]);
    }
  };

  const selectedSearchBarValue = (value) => {
    if (value !== null) {
      setSearchBarId(value?.id);
      setSearchBarString("");
    } else {
      setSearchBarId(null);
    }
  };

  // useMemo(() => {
  //   if (getItemType === "Item") {
  //     populateItemTable();
  //     setPackagingKitList([]);
  //     setPackagingKitItemsList([]);
  //   } else if (getItemType === "Kit") {
  //     populateKitTable();
  //     setPackagingKitItemsList([]);
  //     setPackagingItemList([]);
  //   }
  // }, [getItemType]);

  useMemo(() => {
    populateKitTable();
    setPackagingKitItemsList([]);
    setPackagingItemList([]);
  }, [
    kitListingObject?.fromDate,
    kitListingObject?.toDate,
    kitListingObject?.searchId,
    kitListingObject?.searchString,
  ]);

  useEffect(() => {
    // useGetUserActions(location?.state?.menuId).then((response) => {
    //   setUserActions(response);
    // });

    // getStoreDropdown(getUserInfo?.loginUnitId).then((response) => {
    //   setStoreOptions(response.data?.result);
    // });
  }, []);

  return (
    <div className="px-4">
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-3 mt-2">
        {/* <SearchBar
          name="searchByItem"
          placeholder="Search By Item / Kit Name"
          searchIcon={true}
          isClearable={true}
          handleInputChange={handleItemKitChange}
          dataArray={itemKitOptions}
          onChange={selectedSearchBarValue}
        /> */}
        <div className="grid grid-cols-2 gap-2">
          <DatePickerField
            control={control}
            name="fromDate"
            label="From Date"
            inputFormat="dd-MM-yyyy"
          />
          <DatePickerField
            control={control}
            name="toDate"
            label="To Date"
            inputFormat="dd-MM-yyyy"
          />
        </div>
        <SearchDropdown
          control={control}
          name="fromStore"
          placeholder="From Store"
          dataArray={storeOptions}
          inputValue={searchBarString}
          isClearable
          handleInputChange={handleFromStoreChange}
          onChange={(selected) => {
            console.log("Selected fromStore:", selected);
          }}
        />
        <div className="flex space-x-2 lg:justify-end xl:justify-start lg:col-span-3 xl:col-span-1 2xl:col-span-2">
          <CommonButton
            type="button"
            searchIcon={true}
            className="bg-customBlue text-white"
            // onClick={() => {
            //   setKitListingObject((kitListingObject) => ({
            //     ...kitListingObject,
            //     fromDate: getFromDate
            //       ? format(getFromDate, "dd-MM-yyyy")
            //       : null,
            //     toDate: getToDate ? format(getToDate, "dd-MM-yyyy") : null,
            //     searchId: searchBarId ? searchBarId : null,
            //     searchString: searchBarString ? searchBarString : "",
            //   }));
            // }}
            onClick={handleReceiveCSSDSearch}
          />
          <CommonButton
            type="button"
            label="Reset"
            className="border border-customRed text-customRed"
            onClick={() => {
              setKitListingObject((kitListingObject) => ({
                ...kitListingObject,
                searchId: null,
                searchString: "",
                fromDate: null,
                toDate: null,
              }));
              setValue("fromDate", null);
              setValue("toDate", null);
              setSearchBarId(null);
              setSearchBarString("");
            }}
          />
        </div>
      </div>
      <div className="grid lg:grid-cols-2 justify-between">
        <div className="flex space-x-2 items-center mt-3">
          <fieldset className="hidden">
            <RadioField
              control={control}
              name="itemType"
              dataArray={itemType}
            />
          </fieldset>
          {getItemType === "Kit" ? (
            <div className="w-80 hidden">
              <SearchDropdown
                control={control}
                searchIcon={true}
                name="itemKit"
                dataArray={itemKitOptions}
                isSearchable={true}
                placeholder="Search Item Kit"
                isClearable={true}
                handleInputChange={handleItemKitChange}
              />
            </div>
          ) : (
            <div className="w-80 hidden">
              <SearchDropdown
                control={control}
                searchIcon={true}
                name="itemKit"
                // dataArray={itemKitOptions}
                isSearchable={true}
                placeholder="Search Item Name"
                isClearable={true}
              // handleInputChange={handleItemKitChange}
              />
            </div>
          )}
          <CommonButton
            type="button"
            searchIcon={true}
            className="bg-customBlue text-white hidden"
          />
        </div>
        <div className="">
          {packagingKitItemsList?.length > 0 && (
            // <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            //   <Tabs
            //     value={values}
            //     onChange={handleChange}
            //     aria-label="basic tabs example"
            //     variant="scrollable"
            //   >
            //     {packagingKitItemsList?.map((val, ind) => (
            //       <Tab label={val?.KitName} {...a11yProps(ind)} />
            //     ))}
            //   </Tabs>
            // </Box>

            <div className="flex space-x-4 border-b border-gray-300">
              {finalTabs.map((tab, index) => (
                <button
                  key={index}
                  className={`px-3 py-1 font-semibold ${values === index
                    ? "text-customBlue border-b-2 border-customBlue"
                    : "text-gray-500"
                    }`}
                  onClick={() => setValues(index)}
                >
                  {tab.KitName || `Kit ${tab.kitId}`}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
      {getItemType === "Kit" ? (
        <div className="grid xl:grid-cols-2 xl:gap-x-2">
          {packagingKitList?.length > 0 ? (
            <CommonTransactionTable
              dataResult={packagingKitList}
              page={kitPage}
              setPage={setKitPage}
              count={kitCount}
              rowsPerPage={kitRowsPerPage}
              renderInput={renderInputKit}
              populateTable={populateKitTable}
              editableColumns={["Select"]}
              highlightRow={false}
              tableClass={"h-96"}
              removeHeaders={[
                "cssdLotNo",
                "createdBy",
                "transferDate",
                "transferStatus",
                "transferred_by",
                "Transfer Date",
                "Receive Date",
                "Transferred By",
                "Received By",
                "Ot Details Id",
                "Item Id",
                "Created Date",
                "Last Modified Date",
                "Cleaning Status",
                "Decontamination Status",
                "Sterilization Qty",
                "Sterilization Status",
                "Wrapped Qty",
                "Wrapping Status",
                "Cleaned By",
                "Wrapped By",
                "Sterilized By",
                "Receive Status",
                "Sterilization Status Type",
                "Transfer Status",
                "Sterilization End By",
                "Sterilization Start By",
                "Transferred By",
                "Id",
                "Created Date",
                "Created By",
                "Last Modified By",
                "Status",
                "Sent By",
                "Used Quantity",
                "Transfer Qty",
                "Item Code",
                "Item Name",
                "Cleaned Qty",
                "Receive Qty",
                "Sterilization Method Id",
                "Sterilization Method Name",
                "Sterilization Equipment Id",
                "Sterilization Equipment Name",
                "Wrapper Type Name",
                "Wrapper Type Id",
                "Wrapping Method Name",
                "Wrapping Method Id",
                "AddToStock Qty",
                "Sterilization Start Date",
                "Sterilization End Date",
                "Sterilization Equipment",
                "Machine Id",
                "Wrapping Start Date",
                "Wrapping End Date",
                "Sr No",
                "Cleaning Start Date",
                "Cleaning End Date",
                "Issue Date",
                "Issue Qty",
                "Issue Status",
                "Issued By",
                "Disposed Date",
                "Disposed Qty",
                "Disposed By",
                "Disposed Reason",
                "Item BatchNo",
                "Wrapper Type",
                "Wrapping Method",
                "Temperature",
                "Pressure",
                "Wrapper Type Qty",
                "Cssd Transfer Id",
              ]}
            />
          ) : (
            <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )}

          {/* {packagingKitItemsList?.length > 0 ? (
            <div className="mt-4">
              {packagingKitItemsList?.map((kit, kitIndex) => {
                return (
                  <>
                    {values === kitIndex && (
                      <div className="">
                        <div className="flex justify-between font-semibold text-sm bg-[#F1F1F1] px-2 py-1">
                          <label className="">{kit.KitName}</label>
                          <label className="">
                            Items Qty : {kit?.kitItemList?.length}
                          </label>
                        </div>
                        {kit?.kitItemList?.length > 0 ? (
                          <CommonTransactionTable
                            dataResult={kit?.kitItemList}
                            tableClass={"-mt-1 h-96"}
                            renderInput={renderInputKitItem}
                            editableColumns={["AddToStock Qty"]}
                            highlightRow={false}
                            removeHeaders={[
                              "Transfer Date",
                              "Receive Date",
                              "Transferred By",
                              "Received By",
                              "Ot Details Id",
                              "Item Id",
                              "Created Date",
                              "Last Modified Date",
                              "Cleaning Status",
                              "Decontamination Status",
                              "Sterilization Qty",
                              "Sterilization Status",
                              "Wrapping Status",
                              "Cleaned By",
                              "Wrapped By",
                              "Sterilized By",
                              "Receive Status",
                              "Sterilization Status Type",
                              "Transfer Status",
                              "Sterilization End By",
                              "Sterilization Start By",
                              "Transferred By",
                              "Id",
                              "Created Date",
                              "Created By",
                              "Last Modified By",
                              "Status",
                              "Sent By",
                              "Used Quantity",
                              "Transfer Qty",
                              "Sterilization Method Id",
                              "Sterilization Method Name",
                              "Sterilization Equipment Id",
                              "Sterilization Equipment Name",
                              "Wrapper Type Name",
                              "Wrapper Type Id",
                              "Wrapping Method Name",
                              "Wrapping Method Id",
                              "Sterilization Start Date",
                              "Sterilization End Date",
                              "Sterilization Equipment",
                              "Machine Id",
                              "Wrapping Start Date",
                              "Wrapping End Date",
                              "Sr No",
                              "Item Kit Code",
                              "Cleaning Start Date",
                              "Cleaning End Date",
                              "Issue Date",
                              "Issue Qty",
                              "Issue Status",
                              "Issued By",
                              "Disposed Date",
                              "Disposed By",
                              "Item Kit Name",
                              "Old Cleaned Qty",
                              "Kit BatchNo",
                              "Receive Qty",
                              "Disposed Qty",
                              "Disposed Reason",
                              "Select",
                              "Wrapper Type",
                              "Wrapping Method",
                              "Cleaned Qty",
                              "Temperature",
                              "Pressure",
                              "Wrapped Qty",
                              "Wrapper Type Qty",
                              "Cssd Transfer Id",
                              "Old AddToStock Qty",
                            ]}
                          />
                        ) : (
                          <div className="w-full h-60 flex justify-center items-center font-semibold border border-gray-300 rounded">
                            No items found against kit...!
                          </div>
                        )}
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          ) : (
            <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )} */}

          {finalTabs?.length > 0 ? (
            <div className="mt-1 p-0">
              {finalTabs.map((kit, index) =>
                index === values ? (
                  <div key={index} className="mt-1 p-0">
                    <div className="flex justify-between font-semibold text-sm bg-[#F1F1F1] px-2 py-1">
                      <label>{kit.KitName}</label>
                      <label>Items Qty : {kit.items?.length}</label>
                    </div>
                    {kit?.items?.length > 0 ? (
                      <CommonTransactionTable
                        dataResult={kit.items}
                        tableClass="-mt-1 h-96"
                        renderInput={renderInputKitItem}
                        highlightRow={false}
                        editableColumns={["Select"]}
                        removeHeaders={[
                          // "id",
                          "id",
                          // "kitId",
                          "kitId",
                          "Transfer Date",
                          "Receive Date",
                          "Transferred By",
                          "Received By",
                          "Ot Details Id",
                          "Item Id",
                          "Created Date",
                          "Last Modified Date",
                          "Cleaning Status",
                          "Decontamination Status",
                          "Sterilization Qty",
                          "Sterilization Status",
                          "Wrapping Status",
                          "Cleaned By",
                          "Wrapped By",
                          "Sterilized By",
                          "Receive Status",
                          "Sterilization Status Type",
                          "Transfer Status",
                          "Sterilization End By",
                          "Sterilization Start By",
                          "Transferred By",
                          "Id",
                          "Created Date",
                          "Created By",
                          "Last Modified By",
                          "Status",
                          "Sent By",
                          "Used Quantity",
                          "Transfer Qty",
                          "Sterilization Method Id",
                          "Sterilization Method Name",
                          "Sterilization Equipment Id",
                          "Sterilization Equipment Name",
                          "Wrapper Type Name",
                          "Wrapper Type Id",
                          "Wrapping Method Name",
                          "Wrapping Method Id",
                          "Sterilization Start Date",
                          "Sterilization End Date",
                          "Sterilization Equipment",
                          "Machine Id",
                          "Wrapping Start Date",
                          "Wrapping End Date",
                          "Sr No",
                          "Item Kit Code",
                          "Cleaning Start Date",
                          "Cleaning End Date",
                          "Issue Date",
                          "Issue Qty",
                          "Issue Status",
                          "Issued By",
                          "Disposed Date",
                          "Disposed By",
                          "Item Kit Name",
                          "Old Cleaned Qty",
                          "Kit BatchNo",
                          "Receive Qty",
                          "Disposed Qty",
                          "Disposed Reason",
                          // "Select",
                          "Wrapper Type",
                          "Wrapping Method",
                          "Cleaned Qty",
                          "Temperature",
                          "Pressure",
                          "Wrapped Qty",
                          "Wrapper Type Qty",
                          "Cssd Transfer Id",
                          "Old AddToStock Qty",
                        ]}
                      />
                    ) : (
                      <div className="w-full h-60 flex justify-center items-center font-semibold border border-gray-300 rounded">
                        No items found against kit...!
                      </div>
                    )}
                  </div>
                ) : null
              )}
            </div>
          ) : (
            <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )}

        </div>
      ) : (
        <div>
          {packagingItemList?.length > 0 ? (
            <CommonTransactionPaginationTable
              dataResult={packagingItemList}
              page={page}
              setPage={setPage}
              count={count}
              rowsPerPage={rowsPerPage}
              tableHeading={"Item List"}
              renderInput={renderInputItem}
              populateTable={populateItemTable}
              editableColumns={["Select", "AddToStock Qty"]}
              highlightRow={false}
              removeHeaders={[
                "Transfer Date",
                "Receive Date",
                "Transferred By",
                "Received By",
                "Ot Details Id",
                "Item Id",
                "Created Date",
                "Last Modified Date",
                "Cleaning Status",
                "Decontamination Status",
                "Sterilization Qty",
                "Sterilization Status",
                "Wrapping Status",
                "Cleaned By",
                "Wrapped By",
                "Sterilized By",
                "Receive Status",
                "Sterilization Status Type",
                "Transfer Status",
                "Sterilization End By",
                "Sterilization Start By",
                "Transferred By",
                "Id",
                "Created Date",
                "Created By",
                "Last Modified By",
                "Status",
                "Sent By",
                "Used Quantity",
                "Transfer Qty",
                "Sterilization Method Id",
                "Sterilization Method Name",
                "Sterilization Equipment Id",
                "Sterilization Equipment Name",
                "Wrapper Type Name",
                "Wrapper Type Id",
                "Wrapping Method Name",
                "Wrapping Method Id",
                "Sterilization Start Date",
                "Sterilization End Date",
                "Sterilization Equipment",
                "Machine Id",
                "Wrapping Start Date",
                "Wrapping End Date",
                "Sr No",
                "Item Kit Code",
                "Cleaning Start Date",
                "Cleaning End Date",
                "Issue Date",
                "Issue Qty",
                "Issue Status",
                "Issued By",
                "Disposed Date",
                "Disposed By",
                "Item Kit Name",
                "Old Cleaned Qty",
                "Kit BatchNo",
                "Receive Qty",
                "Disposed Qty",
                "Disposed Reason",
                "Wrapper Type",
                "Wrapping Method",
                "Cleaned Qty",
                "Temperature",
                "Pressure",
                "Wrapped Qty",
                "Wrapper Type Qty",
                "Cssd Transfer Id",
                "Old AddToStock Qty",
              ]}
            />
          ) : (
            <div className="my-2 w-full h-96 flex justify-center items-center font-semibold border border-gray-300 rounded">
              No Records Found...
            </div>
          )}
        </div>
      )}
      <div className="flex justify-end">
        <CommonButton
          type="button"
          label={"Add To Stock"}
          className="bg-customGreen text-white"
          onClick={() => {
            let itemDetailsArray =
              getItemType === "Item"
                ? packagingItemList?.filter((fil) => fil.Select === true)
                : packagingKitItemsList?.flatMap((val) => val?.kitItemList);
            // ?.filter((fil) => fil.Select === true);
            if (itemDetailsArray?.length > 0) {
              setOpenPostModal(true);
            } else if (itemDetailsArray?.length === 0) {
              warningAlert("Select items for add to stock...!");
            }
          }}
        />
      </div>
      <CommonBackDrop openBackdrop={openBackdrop} />
      <ConfirmationModal
        confirmationOpen={openPostModal}
        confirmationHandleClose={() => setOpenPostModal(false)}
        confirmationSubmitFunc={addToStockList}
        confirmationLabel="Confirmation "
        confirmationMsg={"Are you sure want to save CSSD items ?"}
        confirmationButtonMsg="Confirm"
      />
    </div>
  );
};

export default SterilizationProcessingAddToStock;